import type {
  BetterstartCommandRuntime,
  UninstallCommandOptions
} from '@cli-types/core-engine/commands.js'
import { Command } from 'commander'

export function createUninstallCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('uninstall')
    .description('Remove all Admin files and undo modifications made by betterstart init')
    .option('-f, --force', 'Skip all confirmation prompts', false)
    .option('--cwd <path>', 'Project root path')
    .action((options: UninstallCommandOptions) => runtime.runUninstall(options))
}
